import { AppSettings } from "../../config/AppSettings";

export function getS3KeyFromDateAndObjectKey(date: Date, objectKey: string) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  return `year=${year}/month=${month}/day=${day}/${objectKey}`;
}

export function defaultSnapshotFileName(date: Date) {
  const year = date.getUTCFullYear();
  const month = date.getUTCMonth() + 1;
  const day = date.getUTCDate();
  const hour = date.getUTCHours();
  const minute = date.getUTCMinutes();
  const seconds = date.getUTCSeconds();
  return `${year}-${month}-${day}T${hour}${minute}${seconds}Z`;
}

export function getSnapshotS3BucketUri() {
  return `s3://${AppSettings().snapshotBucket}/`;
}

// Matches "Safe Characters" from S3 object key naming guidelines (except ".")
// https://docs.aws.amazon.com/AmazonS3/latest/userguide/object-keys.html#object-key-guidelines
export const s3KeyRegex = new RegExp("^[\\w!'*()-]*$");
